var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedicationsEmptyState(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 161,
    viewBox: "0 0 240 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1166_79711)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.431 44.9013H124.773C123.304 44.9012 121.858 44.5382 120.564 43.8447C119.269 43.1512 118.166 42.1487 117.352 40.9261L104.839 22.0856C104.024 20.8576 102.917 19.851 101.618 19.1557C100.318 18.4604 98.8664 18.0982 97.3925 18.1016H57.5714C47.7202 18.1013 39.7344 26.1003 39.7344 35.968V125.301C39.7344 135.169 47.7202 143.168 57.5714 143.168H182.431C192.282 143.168 200.268 135.169 200.268 125.301V62.768C200.268 52.9005 192.282 44.9013 182.431 44.9013Z",
    fill: "#FDFDFD",
    stroke: "#D9D8DF",
    strokeWidth: 1.38222
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0016 114.364C84.0016 105.969 77.1963 99.1641 68.8016 99.1641C60.4068 99.1641 53.6016 105.969 53.6016 114.364C53.6016 122.759 60.4068 129.564 68.8016 129.564C77.1963 129.564 84.0016 122.759 84.0016 114.364Z",
    fill: "#006546"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.4 101.57H94.1333C92.9551 101.57 92 102.525 92 103.704C92 104.882 92.9551 105.837 94.1333 105.837H182.4C183.578 105.837 184.533 104.882 184.533 103.704C184.533 102.525 183.578 101.57 182.4 101.57Z",
    fill: "#D9D8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.4 111.969H94.1333C92.9551 111.969 92 112.924 92 114.102C92 115.28 92.9551 116.235 94.1333 116.235H182.4C183.578 116.235 184.533 115.28 184.533 114.102C184.533 112.924 183.578 111.969 182.4 111.969Z",
    fill: "#D9D8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.4 122.367H94.1333C92.9551 122.367 92 123.322 92 124.501C92 125.679 92.9551 126.634 94.1333 126.634H182.4C183.578 126.634 184.533 125.679 184.533 124.501C184.533 123.322 183.578 122.367 182.4 122.367Z",
    fill: "#D9D8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0016 75.4344C84.0016 67.0396 77.1963 60.2344 68.8016 60.2344C60.4068 60.2344 53.6016 67.0396 53.6016 75.4344C53.6016 83.8291 60.4068 90.6344 68.8016 90.6344C77.1963 90.6344 84.0016 83.8291 84.0016 75.4344Z",
    fill: "#006546"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.4 62.6328H94.1333C92.9551 62.6328 92 63.5879 92 64.7661C92 65.9444 92.9551 66.8995 94.1333 66.8995H182.4C183.578 66.8995 184.533 65.9444 184.533 64.7661C184.533 63.5879 183.578 62.6328 182.4 62.6328Z",
    fill: "#D9D8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.4 73.0312H94.1333C92.9551 73.0312 92 73.9864 92 75.1646C92 76.3428 92.9551 77.2979 94.1333 77.2979H182.4C183.578 77.2979 184.533 76.3428 184.533 75.1646C184.533 73.9864 183.578 73.0312 182.4 73.0312Z",
    fill: "#D9D8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.4 83.4297H94.1333C92.9551 83.4297 92 84.3848 92 85.563C92 86.7412 92.9551 87.6964 94.1333 87.6964H182.4C183.578 87.6964 184.533 86.7412 184.533 85.563C184.533 84.3848 183.578 83.4297 182.4 83.4297Z",
    fill: "#D9D8DF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1166_79711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.082 82.3375V68.5375C63.082 68.2061 63.3507 67.9375 63.682 67.9375H72.2085C72.3676 67.9375 72.5202 68.0007 72.6328 68.1132L74.9063 70.3868C75.0188 70.4993 75.082 70.6519 75.082 70.811V82.3375C75.082 82.6689 74.8134 82.9375 74.482 82.9375H63.682C63.3507 82.9375 63.082 82.6689 63.082 82.3375Z",
    stroke: "#FDFDFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.082 73.9375L72.082 73.9375",
    stroke: "#FDFDFD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.082 79.9375L72.082 79.9375",
    stroke: "#FDFDFD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.082 76.9375L69.082 76.9375",
    stroke: "#FDFDFD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.082 67.9375V70.3375C72.082 70.6689 72.3507 70.9375 72.682 70.9375H75.082",
    stroke: "#FDFDFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1166_79711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.082 120.267V106.467C63.082 106.136 63.3507 105.867 63.682 105.867H72.2085C72.3676 105.867 72.5202 105.93 72.6328 106.043L74.9063 108.316C75.0188 108.429 75.082 108.582 75.082 108.741V120.267C75.082 120.599 74.8134 120.867 74.482 120.867H63.682C63.3507 120.867 63.082 120.599 63.082 120.267Z",
    stroke: "#FDFDFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.082 111.867L72.082 111.867",
    stroke: "#FDFDFD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.082 117.867L72.082 117.867",
    stroke: "#FDFDFD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.082 114.867L69.082 114.867",
    stroke: "#FDFDFD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.082 105.867V108.267C72.082 108.599 72.3507 108.867 72.682 108.867H75.082",
    stroke: "#FDFDFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1166_79711"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 160,
    fill: "white",
    transform: "translate(0 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1166_79711"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(60.082 66.4375)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1166_79711"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(60.082 104.367)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicationsEmptyState);
export default __webpack_public_path__ + "static/media/medications-empty-state.44e05e69dd84e4b62f195f49125cfe4a.svg";
export { ForwardRef as ReactComponent };